<template>
  <div
      id="sidebarMenu"
      class="p-3 d-none d-md-flex flex-column min-vh-100 flex-shrink-0 sidebar collapse"
  >
    <ul
        class="nav nav-pills flex-column mb-auto pt-5 rounded-4 h-100-pct bg-primary font-sm"
    >
      <!-- Dashboard -->
      <li class="nav-item" :class="getColorClass('dashboard')">
        <router-link
            :to="{ name: 'dashboard' }"
            class="nav-link d-flex align-items-centert text-white"
        >
          <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 24 24"
              class="small-icon"
              fill="currentColor"
          >
            <g data-name="Layer 2">
              <g data-name="grid">
                <rect width="24" height="24" opacity="0"></rect>
                <path
                    d="M9 3H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM5 9V5h4v4z"
                ></path>
                <path
                    d="M19 3h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-4 6V5h4v4z"
                ></path>
                <path
                    d="M9 13H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm-4 6v-4h4v4z"
                ></path>
                <path
                    d="M19 13h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm-4 6v-4h4v4z"
                ></path>
              </g>
            </g>
          </svg>
          <span class="ms-2">Dashboard</span>
        </router-link>
      </li>

      <!-- Customers -->
      <li class="nav-item" :class="getColorClass('customer')">
        <router-link
            :to="{ name: 'customers' }"
            class="nav-link d-flex align-items-center text-white"
        >
          <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 24 24"
              class="eva eva-award-outline small-icon"
              fill="currentColor"
          >
            <g data-name="Layer 2">
              <g data-name="award">
                <rect width="24" height="24" opacity="0"></rect>
                <path
                    d="M19 20.75l-2.31-9A5.94 5.94 0 0 0 18 8 6 6 0 0 0 6 8a5.94 5.94 0 0 0 1.34 3.77L5 20.75a1 1 0 0 0 1.48 1.11l5.33-3.13 5.68 3.14A.91.91 0 0 0 18 22a1 1 0 0 0 1-1.25zM12 4a4 4 0 1 1-4 4 4 4 0 0 1 4-4zm.31 12.71a1 1 0 0 0-1 0l-3.75 2.2L9 13.21a5.94 5.94 0 0 0 5.92 0L16.45 19z"
                ></path>
              </g>
            </g>
          </svg>
          <span class="ms-2">Customers</span>
        </router-link>
      </li>

      <!-- Markets -->
      <li class="nav-item" :class="getColorClass('markets')">
        <router-link
            :to="{ name: 'markets' }"
            class="nav-link d-flex align-items-center text-white"
        >
          <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-map small-icon"
          >
            <polygon
                points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"
            ></polygon>
            <line x1="8" y1="2" x2="8" y2="18"></line>
            <line x1="16" y1="6" x2="16" y2="22"></line>
          </svg>
          <span class="ms-2">Markets</span>
        </router-link>
      </li>

      <!-- Inventory Management Dropdown -->
      <li 
          class="nav-item dropdown-collapsible"
          :class="getDropdownColorClass(['providers', 'asset-owners', 'inventory-frames', 'media-upload'])"
          @mouseenter="hoveredDropdown = 'inventory'"
          @mouseleave="hoveredDropdown = null"
      >
        <div 
            class="nav-link d-flex align-items-center text-white"
        >
          <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-package small-icon"
          >
            <line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line>
            <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
            <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
            <line x1="12" y1="22.08" x2="12" y2="12"></line>
          </svg>
          <span class="ms-2">Inventory Management</span>
          <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="ms-auto dropdown-arrow"
              :class="{ 'rotate-90': hoveredDropdown === 'inventory' }"
          >
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </div>
        <ul 
            class="dropdown-submenu"
            :class="{ 'show': hoveredDropdown === 'inventory' }"
        >
          <li>
            <router-link
                :to="{ name: 'providers' }"
                class="dropdown-item text-white"
                :class="{ 'active': $route.name === 'providers' }"
            >
              <span class="ms-2">Providers</span>
            </router-link>
          </li>
          <li>
            <router-link
                :to="{ name: 'asset-owners' }"
                class="dropdown-item text-white"
                :class="{ 'active': $route.name === 'asset-owners' }"
            >
              <span class="ms-2">Asset Owners</span>
            </router-link>
          </li>
          <li>
            <router-link
                :to="{ name: 'inventory-frames' }"
                class="dropdown-item text-white"
                :class="{ 'active': $route.name === 'inventory-frames' }"
            >
              <span class="ms-2">Inventory</span>
            </router-link>
          </li>
          <li>
            <router-link
                :to="{ name: 'media-upload' }"
                class="dropdown-item text-white"
                :class="{ 'active': $route.name === 'media-upload' }"
            >
              <span class="ms-2">Upload</span>
            </router-link>
          </li>
        </ul>
      </li>

      <!-- AI Tools and Insights Dropdown -->
      <li 
          class="nav-item dropdown-collapsible"
          :class="getDropdownColorClass(['assistant', 'ai-insights', 'ai-debug-logs'])"
          @mouseenter="hoveredDropdown = 'ai-tools'"
          @mouseleave="hoveredDropdown = null"
      >
        <div 
            class="nav-link d-flex align-items-center text-white"
        >
          <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-zap small-icon"
          >
            <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
          </svg>
          <span class="ms-2">AI Tools and Insights</span>
          <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="ms-auto dropdown-arrow"
              :class="{ 'rotate-90': hoveredDropdown === 'ai-tools' }"
          >
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </div>
        <ul 
            class="dropdown-submenu"
            :class="{ 'show': hoveredDropdown === 'ai-tools' }"
        >
          <li>
            <router-link
                :to="{ name: 'assistant' }"
                class="dropdown-item text-white"
                :class="{ 'active': $route.name === 'assistant' }"
            >
              <span class="ms-2">Atlas</span>
            </router-link>
          </li>
          <li>
            <router-link
                :to="{ name: 'ai-insights' }"
                class="dropdown-item text-white"
                :class="{ 'active': $route.name === 'ai-insights' }"
            >
              <span class="ms-2">AI Insights</span>
            </router-link>
          </li>
          <li>
            <router-link
                :to="{ name: 'ai-debug-logs' }"
                class="dropdown-item text-white"
                :class="{ 'active': $route.name === 'ai-debug-logs' }"
            >
              <span class="ms-2">Debug Logs</span>
            </router-link>
          </li>
        </ul>
      </li>

      <!-- Attribution/Retargeting Dropdown -->
      <li 
          class="nav-item dropdown-collapsible" 
          :class="getDropdownColorClass(['attribution', 'devices', 'pixels'])"
          @mouseenter="hoveredDropdown = 'attribution'"
          @mouseleave="hoveredDropdown = null"
      >
        <div 
            class="nav-link d-flex align-items-center text-white"
        >
          <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-target small-icon"
          >
            <circle cx="12" cy="12" r="10"></circle>
            <circle cx="12" cy="12" r="6"></circle>
            <circle cx="12" cy="12" r="2"></circle>
          </svg>
          <span class="ms-2">Attribution/Retargeting</span>
          <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="ms-auto dropdown-arrow"
              :class="{ 'rotate-90': hoveredDropdown === 'attribution' }"
          >
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </div>
        <ul 
            class="dropdown-submenu"
            :class="{ 'show': hoveredDropdown === 'attribution' }"
        >
          <li>
            <router-link
                :to="{ name: 'attribution' }"
                class="dropdown-item text-white"
                :class="{ 'active': $route.name === 'attribution' }"
            >
              <span class="ms-2">Studies</span>
            </router-link>
          </li>
          <li>
            <router-link
                :to="{ name: 'attribution-feasibility' }"
                class="dropdown-item text-white"
                :class="{ 'active': $route.name === 'attribution-feasibility' }"
            >
              <span class="ms-2">Feasibility</span>
            </router-link>
          </li>
          <li>
            <router-link
                :to="{ name: 'devices' }"
                class="dropdown-item text-white"
                :class="{ 'active': $route.name === 'devices' }"
            >
              <span class="ms-2">Device Export</span>
            </router-link>
          </li>
          <li>
            <router-link
                :to="{ name: 'pixels' }"
                class="dropdown-item text-white"
                :class="{ 'active': $route.name === 'pixels' }"
            >
              <span class="ms-2">Pixels</span>
            </router-link>
          </li>
        </ul>
      </li>

      <!-- Developers -->
      <li
          v-if="isDeveloper()"
          class="nav-item"
          :class="getDevColorClass('dev')"
      >
        <router-link
            :to="{ name: 'dev' }"
            class="nav-link d-flex align-items-center text-white"
        >
          <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-terminal small-icon"
          >
            <polyline points="4 17 10 11 4 5"></polyline>
            <line x1="12" y1="19" x2="20" y2="19"></line>
          </svg>
          <span class="ms-2">Developers</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Sidebar",
  data() {
    return {
      model: streetmetrics.model,
      hoveredDropdown: null,
    };
  },
  computed: {
    isStationaryPipelinePath() {
      return this.$route.name === 'stationary-pipeline'
    }
  },
  methods: {
    isDeveloper() {
      return this.model.isDeveloper();
    },
    getColorClass(linkLabel) {
      return "";
    },
    isActive(linkLabel) {
      return this.$route.name.indexOf(linkLabel) > -1;
    },
    getDevColorClass(linkLabel) {
      return "";
    },
    getDropdownColorClass(routeNames) {
      return "";
    },
  },
};
</script>

<style scoped>
#sidebarMenu {
  width: 240px;
}

#sidebarMenu :deep(.nav-item) {
  min-height: 2.5rem;
  flex-shrink: 0;
}

#sidebarMenu :deep(.nav-link) {
  white-space: nowrap;
  min-height: 2.5rem;
  align-items: center;
}

.dropdown-collapsible {
  position: relative;
}

.dropdown-submenu {
  list-style: none;
  padding: 0;
  margin: 0;
  position: absolute;
  left: 100%;
  top: 0;
  min-width: 180px;
  background-color: rgba(0, 0, 0, 0.9);
  border-radius: 0.375rem;
  opacity: 0;
  visibility: hidden;
  transform: translateX(-10px);
  transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s;
  z-index: 1000;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  pointer-events: none;
}

.dropdown-submenu.show {
  opacity: 1;
  visibility: visible;
  transform: translateX(0);
  pointer-events: auto;
}

.dropdown-submenu li {
  margin: 0;
}

.dropdown-submenu .dropdown-item {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  text-decoration: none;
  transition: background-color 0.2s ease;
  border-radius: 0.25rem;
  margin: 0.125rem;
}

.dropdown-submenu .dropdown-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.dropdown-submenu .dropdown-item.active {
  background-color: rgba(255, 255, 255, 0.15);
  font-weight: 500;
}

.dropdown-arrow {
  transition: transform 0.2s ease;
}

.dropdown-arrow.rotate-90 {
  transform: rotate(90deg);
}
</style>
